import RestService from "./rest.service";

class MyFeedback {
  getListFeedbackEmployee() {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/kpi/feedback/employee`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  getListFeedbackRecieved(id) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/kpi/feedback/employee/${id}/received`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  getListFeedbackGiven(id) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/kpi/feedback/employee/${id}/given`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  getFeedbackInbox(id) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/kpi/feedback/member/${id}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  getFeedback(serial, emp_id) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/kpi/feedback/${serial}?employee_id=${emp_id}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  requestFeedback(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/kpi/feedback/request`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  giveFeedback(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/kpi/feedback/give`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  submitFeedback(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/kpi/feedback/submit`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  rejectFeedback(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/kpi/feedback/reject`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  getListEmployeeByPermission(data, serial, serialSendTo) {
    return new Promise((fnResolve, fnReject) => {
      if (serialSendTo !== undefined && serialSendTo !== "") {
        RestService.posts(`app/employee/all/list?exclude=${serial},${serialSendTo}`, data).then(
          (response) => {
            fnResolve(response);
          },
          (response) => {
            fnReject(response);
          }
        );
      } else if (serial !== undefined && serial !== "") {
        RestService.posts(`app/employee/all/list?exclude=${serial}`, data).then(
          (response) => {
            fnResolve(response);
          },
          (response) => {
            fnReject(response);
          }
        );
      } else {
        RestService.posts(`app/employee/all/list`, data).then(
          (response) => {
            fnResolve(response);
          },
          (response) => {
            fnReject(response);
          }
        );
      }
    });
  }

  getListEmployeeByReportTo(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/employee/report_to/list`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  getListFeedbackQuestionMaster() {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/kpi/feedback/question/master`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  getEvaluateFeedback(id, type, evaluate_id) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/kpi/feedback/evaluate/${type}/${id}?form_evaluate_id=${evaluate_id}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  deleteFeedback(id) {
    return new Promise((fnResolve, fnReject) => {
      RestService.delete(`app/kpi/feedback/${id}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

}

export default new MyFeedback();
